__turbopack_context__.v({
  "title": "style-module-scss-module__tu79AW__title",
  "workCard": "style-module-scss-module__tu79AW__workCard",
});
